import React, { useState, useEffect } from 'react'
import { Card, Button, Row, Form, message } from 'antd'
import { SchemaForm } from 'xadmin-form'
import { systemSetting, front_systemSetting } from '../models'
import { Icon, C } from 'xadmin-ui'
import app, { api, use } from 'xadmin'

const DefaultLayout = props => {
  const { children, invalid, handleSubmit, onDelete, schema, submitting, loading } = props;
  const { _t } = app.context;
  return (
    <Form className="form-horizontal" onFinish={handleSubmit} layout="vertical" autoComplete="on">
      <Card style={{ marginTop: 0, borderTop: 'none' }}>
        {children}
        <Row>
          <Button type="submit" htmlType="submit" className="loginBtn ant-btn-primary" loading={loading} disabled={invalid}>{_t('提交')}</Button>
        </Row>
      </Card>
    </Form>
  );
}

const SystemSetting = props => {
  const [token, setToken] = useState()
  const { dispatch } = use('redux')
  const [settings, setSettings] = React.useState({})
  const [loading, setLoading] = React.useState(false)

  useEffect(() => {
    setToken(getCookie('token'))
    api({ name: 'core/setting' }).fetch('')
      .then(({ json }) => {
        if (json) setSettings(json)
      })
      .catch()
  }, [])

  const getCookie = (cname) => {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); }
    }
    return '';
  }
  const onSubmit = (value) => {
    setLoading(true)
    api({ name: 'core/setting' })
      .fetch('', {
        method: 'PATCH',
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...value,
          name: value?.name || value?.reception_name,
          reception_name: value?.reception_name || value?.name,
          logo: value?.logo || value?.reception_logo,
          reception_logo: value?.reception_logo || value?.logo,
          errorLoginAdmin: { duration: { count: 1, time: 60, unit: 'm' } },
          errorLogin: { duration: { count: 1, time: 60, unit: 'm' } },
          onlineCheck: true
        })
      })
      .then(({ json }) => {
        setLoading(false)
        app.go('/login?name=admin')
        dispatch({ type: '@@iot/GET_SETTINGS' })
      })
      .catch(err => {
        message.error(err.message,err?.detail)
      })
  }

  return (
    <div className="setGuideCard">
      <div className="guideContent">
        <div className="loginGuide" >
          <div className="loginBox">
            <div className="cfix">
              <div className="rate-one" style={{ cursor: 'pointer' }} onClick={() => app.go('/systemSettingOne')}>1</div>
              <span className="rate-span"></span>
              {/* <div className="rate-one" style={{ cursor: 'pointer' }} onClick={() => app.go('/systemSettingTwo')}>2</div>
              <span className="rate-span"></span> */}
              <div className="rate-one" >2</div>
            </div>
            <p className="guideUse">系统配置</p>
          </div>
          {
            props?.type && props?.type == 'front' ?
              <SchemaForm
                formKey={'front_systemSetting' + Math.random().toFixed(2)}
                schema={front_systemSetting}
                component={props => <DefaultLayout {...props} loading={loading} />}
                initialValues={settings}
                group={C('Form.SimpleGroup')}
                onSubmit={(value) => onSubmit(value)}
              />
              :
              <SchemaForm
                formKey={'systemSetting' + Math.random().toFixed(2)}
                schema={systemSetting}
                component={props => <DefaultLayout {...props} loading={loading} />}
                initialValues={settings}
                group={C('Form.SimpleGroup')}
                onSubmit={(value) => onSubmit(value)}
              />
          }
        </div>
      </div>
    </div>
  )
}

export default SystemSetting
